import React from "react"
import styles from "./CustomCheckbox.module.css"

interface CustomCheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "onChange"> {
  checked: boolean
  onChange: (checked: boolean, value: string | number) => void
  label?: string
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onChange,
  value,
  label,
  id,
  disabled = false,
  className,
  ...rest
}) => {
  return (
    <label
      htmlFor={id}
      className={`${styles.label} ${disabled ? styles.disabled : ""} ${className ?? ''}`}
      data-testid="CustomCheckbox"
    >
      <input
        data-testid="customCheckbox_suggestionOption"
        type="checkbox"
        id={id}
        value={value}
        checked={checked}
        onChange={(e) => onChange(e.target.checked, e.target.value)}
        disabled={disabled}
        className={styles.input}
        {...rest}
      />
      <span className={styles.box}>
        {checked && (
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M9.10149 3.28022C9.39438 2.98732 9.86915 2.98732 10.162 3.28022C10.4549 3.57311 10.4549 4.04788 10.162 4.34076L5.56585 8.93695C5.27296 9.22981 4.79819 9.22981 4.5053 8.93695C4.50372 8.93538 4.50222 8.93366 4.50066 8.93207L2.03045 6.46186C1.73756 6.16897 1.73758 5.69421 2.03045 5.40131C2.32334 5.10842 2.7981 5.10842 3.09099 5.40131L5.03557 7.34589L9.10149 3.28022Z" fill="white"/>
          </svg>
        )}
      </span>
      {label && <span className={`bodyTextMedium`}>{label}</span>}
    </label>
  )
}

export default CustomCheckbox